import { Box, SvgIcon } from '@mui/material';
import StarSignIcon from 'assets/icons/star-sign.svg';
import StarIcon from 'assets/icons/star.svg';
import { object } from 'prop-types';
import React from 'react';
import {
  getDigitalSignatureCardBody,
  getDigitalSignatureCardTitle,
} from 'utils/getDigitalSignatureCardCopy';
import { I18n } from 'utils/i18n';
import DeleteDraftButton from './DeleteDraftButton';
import EditDraftButton from './EditDraftButton';

const Draft = ({ message }) => {
  const cardTitle = message.digitalSignature ? getDigitalSignatureCardTitle(message) : message.text;
  const cardBody = message.digitalSignature ? getDigitalSignatureCardBody(message) : '';

  return (
    <Box
      sx={{
        position: 'relative',
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        padding: '30px 20px',
        minWidth: '360px',
        boxShadow: '0 7px 22px 0 rgba(2, 2, 3, 0.13)',
        border: 'solid 1px rgba(221, 226, 235, 0.1)',
        borderRadius: '15px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Box
        component="span"
        sx={theme => ({
          position: 'absolute',
          display: 'block',
          top: '10px',
          right: '10px',
          padding: '5px 10px',
          backgroundColor: theme.palette.secondary.extraLight,
          fontSize: '11px',
          fontWeight: '500',
          color: '#738195',
          textTransform: 'uppercase',
        })}
      >
        {I18n.t('AcknowledgementMessage.Draft')}
      </Box>
      <SvgIcon sx={{ color: 'secondary.light', mb: '10px' }}>
        {message.digitalSignature ? <StarSignIcon /> : <StarIcon />}
      </SvgIcon>
      <Box
        component="span"
        sx={{
          fontSize: '12px',
          fontWeight: '500',
          textTransform: 'uppercase',
          mb: '5px',
          color: 'secondary.light',
        }}
      >
        {message.digitalSignature
          ? I18n.t('AcknowledgementMessage.DIGITAL SIGNATURE')
          : I18n.t('AcknowledgementMessage.MANDATORY READ')}
      </Box>
      <Box
        component="h3"
        sx={{
          textAlign: 'center',
          flex: '0 0 auto',
          width: '100%',
          maxWidth: '100%',
          display: 'block',
          fontSize: '20px',
          color: 'secondary.light',
          m: '0 0 8px',
          px: 0.5,
          boxSizing: 'border-box',
          wordBreak: 'break-word',
        }}
      >
        {cardTitle}
      </Box>
      {cardBody ? (
        <Box
          sx={{
            textAlign: 'center',
            width: '100%',
            alignSelf: 'stretch',
            mb: 1.5,
            px: 1,
            boxSizing: 'border-box',
          }}
        >
          <Box
            component="p"
            sx={{
              display: 'inline-flex',
              width: 'auto',
              maxWidth: '100%',
              textAlign: 'left',
              fontSize: '14px',
              lineHeight: 1.45,
              m: 0,
              color: 'secondary.light',
              whiteSpace: 'pre-wrap',
              boxSizing: 'border-box',
            }}
          >
            {cardBody}
          </Box>
        </Box>
      ) : null}
      <EditDraftButton message={message} />
      <DeleteDraftButton message={message} />
    </Box>
  );
};
Draft.propTypes = {
  message: object.isRequired,
};

export default Draft;
